// extracted by mini-css-extract-plugin
export var button = "_ja-2";
export var card = "_ja-0";
export var closeButtonContainer = "_ja-3";
export var iconContainer = "_ja-1";